const serializers = new Map()

export class SerializerFactory {
  static register(serializer) {
    if (
      typeof serializer !== 'object' ||
      typeof serializer.type !== 'string' ||
      typeof serializer.serialize !== 'function' ||
      typeof serializer.deserialize !== 'function'
    ) {
      throw new Error(
        'Invalid serializer: must implement type, serialize() and deserialize()',
      )
    }

    serializers.set(serializer.type, serializer)
  }

  static get(type) {
    const serializer = serializers.get(type)
    if (!serializer)
      throw new Error(`No serializer registered for type: ${type}`)
    return serializer
  }

  static serialize(type, data) {
    return this.get(type).serialize(data)
  }

  static deserialize(type, data) {
    return this.get(type).deserialize(data)
  }
}
